import React from "react"
import { graphql } from "gatsby"
import { CoursesYamlAppointments } from "../../types/graphql-types"
import { momentDependend, fmtDate } from "../util/text"

export const appointmentsQuery = graphql`
  fragment Appointments on CoursesYamlAppointments {
    date {
      end
      start
    }
    note
    rhythm
    room
    videoconference {
      room
      url
    }
    time {
      from
      to
    }
    weekday
  }
`
interface Appointments {
  appointments: CoursesYamlAppointments // | CoursesYamlPartsAppointments
  className?: string
}

export const Location: React.FC<CoursesYamlAppointments> = ({ app }) => (
  <>
    {app.room ? (
      ` in Raum ${app.room}`
    ) : app.videoconference ? (
      <>
        {" "}
        {"per "}
        <a class="text-fb12-blue-400 underline" href={app.videoconference.url}>
          Videokonferenz
        </a>{" "}
      </>
    ) : (
      " "
    )}
  </>
)

const findet_fand = date => momentDependend(date, "findet", "fand")

export const Appointments: React.FC<Appointments> = ({
  appointments,
  className = "",
}) => (
  <div class={className}>
    <div class="font-semibold">Termine</div>

    {appointments ? (
      <ul class={appointments.length > 1 ? "list-disc ml-6" : ""}>
        {appointments.map(app =>
          app.date && app.weekday && app.rhythm && app.time ? (
            app.rhythm == "einmalig" && app.date.start == app.date.end ? (
              <li class="mb-2">
                  Am {app.weekday}, den {fmtDate(app.date.start)}{" "}
                {findet_fand(app.date.end)} ein Einzeltermin von {app.time.from}{" "}
                bis {app.time.to}
                &thinsp;Uhr <Location app={app} /> statt.
              </li>
            ) : (
              <li class="mb-2">
                Die Veranstaltung {findet_fand(app.date.end)} vom{" "}
                {fmtDate(app.date.start)} bis zum {fmtDate(app.date.end)}{" "}
                {app.rhythm} {app.weekday} von {app.time.from} bis {app.time.to}
                &thinsp;Uhr
                <Location app={app} /> statt.
              </li>
            )
          ) : (
            <div>{app.note}</div>
          )
        )}
      </ul>
    ) : (
      "Termine werden noch bekannt gegeben."
    )}
  </div>
)
